import { MetaReducer } from '@ngrx/store';
import { routerReducer } from '@ngrx/router-store';
import { AppState } from '../app.state';
import * as fromAuthReducer from './auth.reducer';
import * as fromAccountReducer from './account.reducer';
import * as fromSharedReducer from './shared.reducer';
import * as fromEncodingReducer from './encoding.reducer';
import * as fromAddressReducer from './address.reducer';
import * as fromDatabaseReducer from './database.reducer';
import { environment } from 'src/environments/environment';


export const reducers = {
  auth: fromAuthReducer.reducer,
  router: routerReducer,
  account: fromAccountReducer.reducer,
  shared: fromSharedReducer.reducer,
  encoding: fromEncodingReducer.reducer,
  address: fromAddressReducer.reducer,
  database: fromDatabaseReducer.reducer,
};

export const metaReducers: MetaReducer<AppState>[] = !environment.production
  ? []
  : [];
